import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });
const index = () =>
  import(
    /* webpackChunkName: "growth-index" */ "@/views/teacherGrowthSystem/index.vue"
  );
const fixedStudent = () =>
  import(
    /*webpackChunkName: "growth-fixed-student"*/ "@/views/teacherGrowthSystem/fixedStudent.vue"
  );
const historyDetail = () =>
  import(
    /*webpackChunkName: "growth-history-detail"*/ "@/views/teacherGrowthSystem/historyDetail.vue"
  );
const upgradeStrategy = () =>
  import(
    /*webpackChunkName: "growth-upgrade-strategy"*/ "@/views/teacherGrowthSystem/upgradeStrategy.vue"
  );
const noAuthority = () =>
  import(
    /*webpackChunkName: "growth-no-authority"*/ "@/views/teacherGrowthSystem/noAuthority.vue"
  );
export default {
  path: "/teacher",
  name: "teacher",
  component: view,
  children: [
    {
      path: "teacherGrowthSystem",
      component: view,
      children: [
        {
          path: "",
          name: "teacherGrowthSystem",
          component: index
        },
        {
          path: "fixedStudent",
          name: "fixedStudent",
          component: fixedStudent
        },
        {
          path: "historyDetail",
          name: "historyDetail2",
          component: historyDetail
        },
        {
          path: "upgradeStrategy",
          name: "upgradeStrategy2",
          component: upgradeStrategy
        },
        {
          path: "noAuthority",
          name: "noAuthority",
          component: noAuthority
        },
        {
          path: "*",
          component: index
        }
      ]
    }
  ]
};
